import React from "react";
import CLINIC_CONFIG from '../../../config/clinicConfig';

const ContactInfo: React.FC = () => (
    <div className="footer-card d-flex flex-column">
        <h5 className="fw-bold mb-3 text-dark">Contact Information</h5>

        <address className="mb-2">
            <a
                href={CLINIC_CONFIG.mapUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none text-dark"
            >
                {CLINIC_CONFIG.address}
            </a>
        </address>

        <div className="footer-mapwrap">
            <a href={CLINIC_CONFIG.mapUrl} target="_blank" rel="noopener noreferrer" className="footer-map-link">
                <div className="footer-map-overlay">View larger map</div>
                <iframe
                    title="Clinic Location"
                    src={CLINIC_CONFIG.iframe}
                    width="100%"
                    height="180"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </a>
        </div>
    </div>
);

export default ContactInfo;
